import service from "../utils/axiosRequest";

export function getUser(data) {
  return service({
    url: "/users",
    method: "get",
    params: { ...data, soft_deleted: false },
    cancelToken: data.cancelToken,
  });
}

export function getUserDetails(data) {
  return service({
    url: `/users/${data.id}`,
    method: "get",
    params: data.params,
  });
}
export function getDeletedUser(data) {
  return service({
    url: "/users",
    method: "get",
    params: { ...data, soft_deleted: true },
  });
}
export function getUserToken(data) {
  return service({
    url: `/auth/token/${data.id}`,
    method: "get",
    params: data.params,
  });
}

export function getAgent(data) {
  return service({
    url: "/users/agents",
    method: "get",
    params: { ...data, soft_deleted: false },
  });
}
export function assignUsers(data) {
  return service({
    url: "/users/assign",
    method: "patch",
    data,
  });
}
export function dismissAssignedUsers(id) {
  return service({
    url: `/users/dismiss/${id}`,
    method: "patch",
  });
}
export function getAssignedUser(id, data) {
  return service({
    url: `/users/${id}`,
    method: "get",
    params: { ...data, soft_deleted: false },
  });
}
export function addNewUser(data) {
  return service({
    url: "/users",
    method: "post",
    data,
  });
}
export function addNewEndUser(data) {
  return service({
    url: "/users/end-users",
    method: "post",
    data,
  });
}

export function updateUserDetails(id, data) {
  return service({
    url: `/users/${id}`,
    method: "patch",
    data,
  });
}

export function resetUserPasswordByAdmin(id, data) {
  return service({
    url: `/users/update-users-password/${id}`,
    method: "patch",
    data,
  });
}
export function updateUserPasswordByOwn(data) {
  return service({
    url: `/auth/update-password`,
    method: "patch",
    data,
  });
}

export function deleteUser(id) {
  return service({
    url: `/users/soft-delete/${id}`,
    method: "delete",
  });
}
export function permanentDeleteUser(id) {
  return service({
    url: `/users/${id}`,
    method: "delete",
  });
}
export function restoreUser(id) {
  return service({
    url: `/users/re-store/${id}`,
    method: "patch",
  });
}

// import request from "../utils/request-v1";

// const ongoingRequests = new Map();

// const createRequestKey = (url, params) => {
//   return `${url}?${new URLSearchParams(params).toString()}`;
// };

// const executeRequest = async (url, method, data) => {
//   const requestKey = createRequestKey(url, data);

//   if (ongoingRequests.has(requestKey)) {
//     return ongoingRequests.get(requestKey); // Return existing promise
//   }

//   const requestPromise = request({ url, method, ...data }).finally(() =>
//     ongoingRequests.delete(requestKey)
//   ); // Clean up

//   ongoingRequests.set(requestKey, requestPromise);
//   return requestPromise;
// };

// export function getUser(data) {
//   console.log(data);
//   return executeRequest("/users", "get", {
//     params: { ...data, soft_deleted: false },
//   });
// }

// export function getDeletedUser(data) {
//   console.log(data);
//   return executeRequest("/users", "get", {
//     params: { ...data, soft_deleted: true },
//   });
// }

// export function assignUsers(data) {
//   return executeRequest("/users/assign", "patch", { data });
// }

// export function addNewUser(data) {
//   console.log(data);
//   return executeRequest("/users", "post", { data });
// }

// export function getUserDetails(id) {
//   return executeRequest(`/users/${id}`, "get", {});
// }

// export function updateUserDetails(id, data) {
//   console.log(id, data);
//   return executeRequest(`/users/${id}`, "patch", { data });
// }

// export function resetUserPasswordByAdmin(id, data) {
//   return executeRequest(`/users/update-users-password/${id}`, "patch", {
//     data,
//   });
// }

// export function updateUserPasswordByOwn(data) {
//   return executeRequest(`/auth/update-password`, "patch", { data });
// }

// export function deleteUser(id) {
//   return executeRequest(`/users/${id}`, "delete", {});
// }

// export function restoreUser(id) {
//   return executeRequest(`/users/re-store/${id}`, "patch", {});
// }
